import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BookOutlined, CheckCircleOutlined, CrownOutlined, DollarCircleOutlined, GlobalOutlined, SafetyCertificateOutlined, StarOutlined, UserOutlined } from '@ant-design/icons';
import { Card, Row, Col, Table, Checkbox, Button } from 'antd';
import { Column } from '@ant-design/plots';
import { getAllBusiness } from '../../../utils/API';

interface BusinessData {
  name: string;
  state: string;
  ratings: number[];
}

interface RankedBusiness {
  rank: number;
  name: string;
  averageRating: number;
  state: string;
}

const Success: React.FC = () => {
  const location = useLocation();
  const { state } = location;
  const [businessdata, setBusinessData] = useState<BusinessData[]>([]);
  const [rankedBusinesses, setRankedBusinesses] = useState<RankedBusiness[]>([]);
  const [loading, setLoading] = useState(false);

  const { businessDetails } = state || {};
  const category = businessDetails?.categoryId;
  const states = businessDetails?.state;


  const galleryImages = businessDetails?.galleryImage?.fileList || [];
  const galleryImages2 = businessDetails?.galleryFileList || [];
  const simpleImageArray = businessDetails?.galleryImage || [];
  console.log("galleryImages", businessDetails);
  console.log("galleryImages.length", galleryImages.length);
  // console.log("businessDetails?.galleryImage?.fileList", businessDetails?.galleryImage?.fileList);
  // console.log("businessDetails?.galleryImage?.fileList", businessDetails?.galleryImage?.fileList);

  // Determine the number of images
  const imageCount =
  Array.isArray(galleryImages) && galleryImages.length > 0
    ? galleryImages.length
    : Array.isArray(simpleImageArray) && simpleImageArray.length > 0
    ? simpleImageArray.length
    : Array.isArray(galleryImages2) && galleryImages2.length > 0
    ? galleryImages2.length
    : 0;


      console.log("imageCount", imageCount);

  // Calculate the completion percentage
  const completionPercentage = Math.min((imageCount / 4) * 100, 100); // Cap at 100%
  


  const navigate = useNavigate();

  
 const handleRedirect = () => {
  navigate('/backend/pricing-plan');
  
   // Replace '/premium-plan' with the desired route
};
const handleRedirect1 = () => {
  navigate('/my-listing');
}

  // Fetch business data
  const handleGetBusiness = async () => {
    try {
      setLoading(true);
      const res = await getAllBusiness(1, category, states , "" , "" , "" , "", "" , "" ); // Fetch data
      console.log("res", res);
      const fetchedData = res.data || [];
      setBusinessData(fetchedData);

      // Process rankings based on average ratings
      processBusinessRankings(fetchedData);
    } catch (error) {
      console.error("Failed to fetch business data", error);
    } finally {
      setLoading(false);
    }
  };

  // Calculate rankings based on average ratings
  const processBusinessRankings = (data: BusinessData[]) => {
    console.log("data", data);
  
    // Step 1: Map and filter businesses with reviews
    const rankings = data
      .filter((business: any) => business.reviews?.length > 0) // Ensure the business has reviews
      .map((business: any) => ({
        name: business.businessName, // Use `businessName` from the data
        state: business.state,
        reviewCount: business.reviews.length, // Count of reviews
        averageRating: business.averageRating || 0, // Default averageRating to 0 if undefined
      }))
      // Step 2: Sort businesses based on review count and average rating
      .sort((a, b) => {
        // Sort by review count first, then by average rating
        if (b.reviewCount === a.reviewCount) {
          return b.averageRating - a.averageRating;
        }
        return b.reviewCount - a.reviewCount;
      })
      // Step 3: Assign rank based on sorted order
      .map((business, index) => ({
        ...business,
        rank: index + 1, // Assign rank based on position in sorted array
      }));
  
    console.log("rankings", rankings);
    setRankedBusinesses(rankings); // Update state with the calculated rankings
  };
  

  useEffect(() => {
    handleGetBusiness();
  }, []);

  // Chart configuration
  const barConfig = {
    data: rankedBusinesses,
    xField: 'name',
    yField: 'averageRating',
    color: '#fbca25',
    barWidthRatio: 0.8,
    xAxis: {
      title: { text: 'Business Name' },
    },
    yAxis: {
      title: { text: 'Average Rating' },
      min: 0,
      max: 5,
    },
   
  };

  // Table columns
  const columns = [
    {
      title: 'Rank',
      dataIndex: 'rank',
      key: 'rank',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'State',
      dataIndex: 'state',
      key: 'state',
    },
    {
      title: 'Leading',
      dataIndex: 'averageRating',
      key: 'averageRating',
      render: (rating: number) => rating.toFixed(2), // Format to 2 decimal places
    },
  ];

  return (
    <div className="mt-28 lg:px-0 lg:ps-0 xl:px-36 xl:ps-36 md:px-10 md:ps-10 sm:ps-5 xs:ps-5">
      <div className="text-center mb-6">
        <h2 className="text-2xl">
          <CheckCircleOutlined className="text-green-500 mr-2" />
          <span className="text-2xl font-bold"> Congratulations! </span>
          Your business is now registered with Net4Surge
        </h2>
      </div>

      <Row  className="p-3 sm:p-0">
        {/* Bar Chart */}
        <Col span={24} sm={12} className='sm:p-2'>
          <Card title="Average Ratings Chart" className="h-full flex flex-col text-center shadow-lg">
            <div style={{ height: '250px' }}>
              <Column {...barConfig} />
            </div>
          </Card>
        </Col>

        {/* Rankings Table */}
        <Col span={24} sm={12} className='sm:p-2'>
          <Card title="Business Rankings Table" className="h-full flex flex-col text-center shadow-lg">
            <Table
              dataSource={rankedBusinesses}
              columns={columns}
              pagination={
                rankedBusinesses.length > 5
                  ? {
                      pageSize: 5,
                      showSizeChanger: false,
                    }
                  : false
              }
              rowKey="rank"
            />
          </Card>
        </Col>
      </Row>
      
  <div className="mt-8 md:p-3 md:p-0">
  <Card className="text-center ">
    <h1 className="flex justify-center items-center text-xl font-bold mb-2">
      <span className="bg-[#F9B138] w-12 h-12 rounded-full p-2 mr-4 flex items-center justify-center">
        <CrownOutlined style={{ fontSize: '30px', color: 'white' }} />
      </span>
      Upgrade your Free Listing Plan
    </h1>
    <p className='flex justify-center items-center'>Get more visibility , get more customers to contact you!</p>
    <Row gutter={8} className="justify-around items-center mt-3 m-0 sm:m-4">
  <Col span={24} sm={12}>
    <ul className="space-y-2 mb-4 text-left">
      <li className="flex items-center">
        <span className="bg-[#F9B138] w-8 h-8 rounded-full flex items-center justify-center mr-2">
          <StarOutlined style={{ color: 'white' }} />
        </span>
        <span className="flex-1 text-left">Get Higher Visibility than Free Listing</span>
        <Checkbox checked className="ml-auto lg:mr-8 xl:mr-8 accent-[#F9B138]" />
      </li>
      <li className="flex items-center">
        <span className="bg-[#F9B138] w-8 h-8 rounded-full flex items-center justify-center mr-2">
          <UserOutlined style={{ color: 'white' }} />
        </span>
        <span className="flex-1 text-left">Build your strong Social Media Presence</span>
        <Checkbox checked className="ml-auto lg:mr-8 xl:mr-8 accent-[#F9B138]" />
      </li>
      <li className="flex items-center">
        <span className="bg-[#F9B138] w-8 h-8 rounded-full flex items-center justify-center mr-2">
          <DollarCircleOutlined style={{ color: 'white' }} />
        </span>
        <span className="flex-1 text-left">Get your Business Consulting Report</span>
        <Checkbox checked className="ml-auto lg:mr-8 xl:mr-8" />
      </li>
    </ul>
  </Col>
  <Col span={24} sm={12}>
    <ul className="space-y-2 mb-4 text-left">
      <li className="flex items-center">
        <span className="bg-[#F9B138] w-8 h-8 rounded-full flex items-center justify-center mr-2">
          <SafetyCertificateOutlined style={{ color: 'white' }} />
        </span>
        <span className="flex-1 text-left">Get N4S Verified Trust Seal and Stamp</span>
        <Checkbox checked className="ml-auto lg:mr-8 xl:mr-8" />
      </li>
      <li className="flex items-center">
        <span className="bg-[#F9B138] w-8 h-8 rounded-full flex items-center justify-center mr-2">
          <BookOutlined style={{ color: 'white' }} />
        </span>
        <span className="flex-1 text-left">Digital Catalogue</span>
        <Checkbox checked className="ml-auto lg:mr-8 xl:mr-8" />
      </li>
      <li className="flex items-center">
        <span className="bg-[#F9B138] w-8 h-8 rounded-full flex items-center justify-center mr-2">
          <GlobalOutlined style={{ color: 'white' }} />
        </span>
        <span className="flex-1 text-left">Get your Own Business Website with SEO</span>
        <Checkbox checked className="ml-auto lg:mr-8 xl:mr-8" />
      </li>
    </ul>
  </Col>
</Row>

    <Button
      type="primary"
      className="mt-4 h-[55px] hover:bg-[#F9B138] text-black font-bold bg-[#F9B138]"
      onClick={handleRedirect}
    >
      Get Premium Plan
    </Button>
  </Card>
</div>
      <div className="mt-8 p-3 md:p-0">
  <Card className='mb-2'>
    <Row align="middle" >
      <Col xs={24} sm={24} md={6} lg={4} className="text-center">
        <div className="flex justify-center items-center">
          <div className="flex items-center justify-center w-24 h-24 rounded-full border-8 border-green-700">
          <h2 className="text-2xl font-bold m-0">{completionPercentage}%</h2>
          </div>
        </div>
      </Col>
      <Col xs={24} sm={24} md={18} className="text-left ">
        <h1 className='text-2xl font-bold'>Your Current Business Profile Score</h1>
        <p className='mt-2'>Increase your profile score and reach out to more users on Net4Surge </p>
        <Button type="primary"
         className="mt-3 h-[55px] text-black font-bold rounded-xl bg-[#F9B138]"
         onClick={handleRedirect1}
         >
          Click Here to Increase Your Score</Button>

      </Col>
    </Row>
  </Card>
</div>
    </div>
  );
};

export default Success;

